import { IconPencil } from "@tabler/icons-react"
import { type FC, useEffect, useState } from "react"

import Form from "@forento/ui/components/Form"
import { cn } from "@forento/ui/utilities/tailwind"

import Button, { SecondaryButton } from "~/components/button"
import { Input } from "~/components/input"
import { query } from "~/utilities/trpc"

type Props = { course: { id: string; name: string }; reload(): Promise<unknown>; className?: string }
const Name: FC<Props> = ({ course, reload, className }) => {
	const [isEditing, setEditing] = useState(false)
	const [name, setName] = useState(course.name)

	useEffect(() => {
		setName(course.name)
	}, [course.name])

	const updateCourse = query.updateCourse.useMutation({
		async onSuccess() {
			await reload()
			setEditing(false)
		},
		onError(error) {
			console.error(error)
		},
	})

	if (!isEditing) {
		return (
			<h1 className={cn("flex items-center gap-2 text-2xl font-bold text-slate-900", className)}>
				<span className="truncate">{course.name}</span>
				<button
					type="button"
					className="text-primary hover:text-primary/80 cursor-pointer"
					onClick={() => setEditing(true)}
				>
					<IconPencil className="size-4" />
				</button>
			</h1>
		)
	}

	return (
		<Form
			onSubmit={() => updateCourse.mutate({ id: course.id, name })}
			className={cn("flex w-full items-center gap-4 text-2xl font-bold text-slate-900", className)}
		>
			<Input
				type="text"
				value={name}
				onChange={setName}
				placeholder="Ange kursnamn"
				autoFocus
				required
				className="flex-1"
			/>
			<Button type="submit" color="green" disabled={updateCourse.isPending}>
				{updateCourse.isPending ? "Sparar..." : "Spara"}
			</Button>
			<SecondaryButton onClick={() => setEditing(false)}>Avbryt</SecondaryButton>
		</Form>
	)
}

export default Name
